import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Target, ShieldCheck, Rocket, HeartHandshake, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import Section from "@/components/Section";

const services = [
  {
    title: "AI Strategy & Vision",
    tagline: "Turn AI from buzzword to boardroom strategy",
    icon: Target,
    link: "/services#strategy",
  },
  {
    title: "AI Governance & Compliance",
    tagline: "Mitigate risk while maximizing AI innovation",
    icon: ShieldCheck,
    link: "/services#governance",
  },
  {
    title: "AI Implementation Leadership",
    tagline: "Move from pilots to production at scale",
    icon: Rocket,
    link: "/services#implementation",
  },
  {
    title: "Ongoing AI Support & Coaching",
    tagline: "Build lasting AI capabilities within your team",
    icon: HeartHandshake,
    link: "/services#support",
  },
];

const Services = () => {
  return (
    <Section
      eyebrow="What we do"
      title={<>How we <span className="text-gradient-brand">help</span></>}
      description="From strategy to implementation, we partner with leadership teams across the full AI journey."
      grid
    >
      <div className="grid md:grid-cols-2 gap-6">
        {services.map((service, index) => {
          const IconComponent = service.icon;
          return (
            <Card
              key={index}
              className="group relative overflow-hidden transition-all duration-300 hover:-translate-y-2 hover:shadow-glow-card border-border/60 hover:border-primary/40 bg-card/80 backdrop-blur-sm"
            >
              <div
                aria-hidden
                className="absolute top-0 left-0 right-0 h-px bg-gradient-brand opacity-0 group-hover:opacity-100 transition-opacity"
              />

              <CardHeader>
                <div className="inline-flex items-center justify-center w-14 h-14 rounded-xl bg-gradient-brand transition-all duration-300 group-hover:scale-110 group-hover:shadow-glow-primary mb-4">
                  <IconComponent className="w-7 h-7 text-primary-foreground" />
                </div>

                <CardTitle className="text-xl md:text-2xl">{service.title}</CardTitle>
                <p className="text-sm font-semibold text-gradient-brand mt-2">
                  {service.tagline}
                </p>
              </CardHeader>

              <CardContent>
                <Link
                  to={service.link}
                  className="inline-flex items-center gap-2 text-primary hover:text-primary/80 transition-colors font-medium"
                >
                  Learn more
                  <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
                </Link>
              </CardContent>
            </Card>
          );
        })}
      </div>
    </Section>
  );
};

export default Services;
